
import { Hero } from "../Figma/Hero";
import { Footer } from "../Figma/Footer";
import { HowItWorks } from "../../components/Figma/HowItWorks";


function HomeComponent() {
  return (
    <div className="min-h-screen w-full flex flex-col">
      <main className="flex-1 w-full mx-auto">
        {/* Hero */}
        <Hero />
                {/* How It Works */}
        <HowItWorks />
      </main>
      <Footer />
    </div>
  );
}

export default HomeComponent;
export { HomeComponent };  